import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closeMenu",
  "use": "icon-closeMenu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-closeMenu\">\n<g id=\"icon-closeMenu_close\">\n<path id=\"icon-closeMenu_Vector\" d=\"M6.34314 17.6569L17.6568 6.34315\" stroke=\"#DBDBDB\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path id=\"icon-closeMenu_Vector_2\" d=\"M17.6569 17.6569L6.34315 6.34315\" stroke=\"#DBDBDB\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol